import axios from 'axios'
import { config } from '../Config/config'

const courierService = {

    getAll: () => {
        const result = axios.get(config.apiUrl + '/kurir')
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }

            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    addData: (data) => {
        const result = axios.post(config.apiUrl + '/kurir', data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })

            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    getById: (id) => {
        const result = axios.get(config.apiUrl + '/kurirById/' + id)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result[0]
                }
            })

            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    EditData: (data) => {
        const result = axios.put(config.apiUrl + '/kurir', data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },


    //delete data
    deleteData: (id) => {
        const result = axios.delete(config.apiUrl + '/kurir/' + id)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })

            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    softDeleteData: (data) => {
        const result = axios.put(config.apiUrl + '/kurirHapus', data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })

            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    getAllFilter: (filter) => {
        const result = axios.post(config.apiUrl + '/kurirFilter', filter)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }

            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },


    countData: () => {
        const result = axios.get(config.apiUrl + '/countKurir')
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result[0]
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    dupeData: (name) => {
        const result = axios.get(config.apiUrl + '/kurir/'+ name)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result[0]
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    }

}

export default courierService